<template>
  <div>
    <div class="controler" @click="play">
      <i class="fa fa-volume-up" v-if="index % 3 === 0"></i>
      <i class="fa fa-volume-down" v-if="index % 3 === 1"></i>
      <i class="fa fa-volume-off" v-if="index % 3 === 2"></i>
      {{ this.status === 'play' ? '停止' : '播放' }}
      <span v-if="duration > 0">({{ Math.ceil(duration) }}s)</span>
    </div>
    <audio :src="src" style="display: none" controls ref="audio" type="audio/amr" @canplay="getDuration">您的浏览器版本过低，不支持语音!</audio>
    <a v-if="/\.amr/.test(audio.src)" :href="src" ref="amr"></a>
  </div>
</template>

<script>
import amrToBase64 from './pVioce/amrToBase64'
import RongIMLib from './pVioce/voice-2.0'
export default {
  props: ['src'],
  data() {
    return {
      audio: '',
      status: 'ready',
      index: 0,
      interval: '',
      duration: 0
    }
  },
  created() {
    if (/\.amr/.test(this.src)) {
      amrToBase64.init(this.src, (data) => {
        // 播放大概时长 用 data.length / 1024
        this.duration = Math.ceil(data.length / 1024) + 2
      })
    }
  },
  mounted() {
    this.audio = this.$refs.audio
    RongIMLib.RongIMVoice.init()
  },
  methods: {
    getDuration() {
      let duration = this.audio.duration
      this.duration = duration
    },
    play() {
      if (this.status === 'ready' || this.status === 'stop') {
        if (/\.amr/.test(this.src)) {
          amrToBase64.init(this.src, (data) => {
            // 播放大概时长 用 data.length / 1024
            this.duration = Math.ceil(data.length / 1024) + 2
            RongIMLib.RongIMVoice.play(data, data.length / 1024 + 2)
          })
        } else {
          this.audio.play()
        }
        this.status = 'play'
        this.interval = setInterval(() => {
          this.index++
          if (this.index / 5 >= this.duration) {
            this.status = 'stop'
            this.index = 0
            clearInterval(this.interval)
          }
        }, 200)
      } else if (this.status === 'play') {
        if (/\.amr/.test(this.src)) {
          RongIMLib.RongIMVoice.stop()
        } else {
          this.audio.pause()
          this.audio.currentTime = 0
        }
        this.status = 'stop'
        clearInterval(this.interval)
        this.index = 0
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base.less';
@bg_color_main: lighten(@main_color, 4%);
audio {
  display: none;
}
.controler {
  background: #35b6a4;
  padding: 0.2rem;
  width: 100%;
  margin: 0;
  color: #ffffff;
  border-radius: 5px;
  position: relative;
  text-indent: 1em;
  box-sizing: border-box;
  .fa {
    margin-right: 1em;
    display: inline-block;
    width: 1em;
    font-size: 1.2em;
  }
}
</style>
